<template>
    <md-content class="survey-label-container md-scrollbar">
        <span v-if="field.name">{{field.name}}</span>
        <div class="survey-group-container__field"
             v-for="(child, index) in field.children"
             v-bind:key="index" v-bind:field="child">
            <survey-field v-bind:field="child"></survey-field>
        </div>
    </md-content>
</template>

<script>
export default {
  name: 'SurveyLabel',
  props: ['field'],
  methods: {
  },
};
</script>

<style src="./SurveyLabel.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyLabel/SurveyLabel.vue